import { parsePhoneNumberFromString } from 'libphonenumber-js/min';
export function isPossiblePhoneNumber(value) {
    if (typeof value !== 'string') {
        return false;
    }
    const phoneNumber = parsePhoneNumberFromString(value);
    if (!phoneNumber) {
        return false;
    }
    return phoneNumber.isPossible();
}
const makeFormatPhoneNumber = (format) => function formatPhoneNumber(value) {
    const phoneNumber = parsePhoneNumberFromString(value);
    if (!phoneNumber) {
        return '';
    }
    return phoneNumber.format(format);
};
export const formatPhoneNumber = makeFormatPhoneNumber('NATIONAL');
export const formatIntlPhoneNumber = makeFormatPhoneNumber('INTERNATIONAL');
export const parsePhoneNumber = parsePhoneNumberFromString;
export { getCountryCallingCode, getCountries } from 'libphonenumber-js/core';
export { PhoneInput } from './components/PhoneInput';
